// const { Employee } = require("../../backend/models/userModel");
// const { Employee } = require("@/backend/models/userModel");

const DEPARTMENTS = {
  MANAGEMENT: "Management",
  HR: "HR department",
  SALES_EXTERNAL: "Sales",
  SALES_INTERNAL_TOOLS_AND_WELDING: "Sales Tools & Welding",
  ADMINISTRATION_TOOLS_AND_WELDING: "Administration Tools & Welding",
  ADMINISTRATION_FACILITIES: "Administration Facilities",
  ADMINISTRATION_GENERAL: "Administration General",
  SALES_INTERNAL_MACHINERY: "Sales Machinery",
  LOGISTICS: "Logistic",
  // PURCHASING: "purchasing",
  MARKETING: "Marketing department",
  SERVICES: "Service department",
  FINANCE: "Financial department",
  AW_TECH: "AW-Tech",
  ANY: "any",
};

const WS_APPLICATIONS = {
  PLANNING: {
    KEY: "PLANNING",
    LABEL: "Planning",
    ACTIONS: {
      GET: "GET",
      CREATE: "CREATE",
      UPDATE: "UPDATE",
      DELETE: "DELETE",
    },
    TYPES: {
      SERVICE: {
        KEY: "SERVICE",
        LABEL: "Service",
      },
      SALES: {
        KEY: "SALES",
        LABEL: "Sales",
      },
      GENERIC: {
        KEY: "GENERIC",
        LABEL: "Generic",
      },
    },
  },
};

const GENERIC_COMPANY_ROLES = {
  SHAREHOLDER: { KEY: "SHAREHOLDER", LABEL: "Aandeelhouder" },
  DIRECTOR: {
    KEY: "DIRECTOR",
    LABEL: "Bedrijfsleider",
  },
  PARTNER: {
    KEY: "PARTNER",
    LABEL: "Partner",
  },
  ADVISOR: {
    KEY: "ADVISOR",
    LABEL: "Adviseur",
  },
  EMPLOYEE: {
    KEY: "EMPLOYEE",
    LABEL: "Werknemer",
  },
  CONSULTANT: {
    KEY: "CONSULTANT",
    LABEL: "Consultant",
  },
  EMPLOYER: {
    KEY: "EMPLOYER",
    LABEL: "Eigenaar",
  },
};

const GENERIC_DEPARTMENT_ROLES = {
  SUPERVISOR: {
    KEY: "SUPERVISOR",
    LABEL: "Supervisor",
  },
  MEMBER: {
    KEY: "MEMBER",
    LABEL: "Lid",
  },
};
const GENERIC_TEAM_ROLES = {
  TEAMLEADER: {
    KEY: "TEAMLEADER",
    LABEL: "Teamleider",
  },
  ADMINISTRATION: {
    KEY: "ADMINISTRATION",
    LABEL: "Administratie",
  },
  SUPPORT: {
    KEY: "SUPPORT",
    LABEL: "Ondersteuning",
  },
  BACKUP: {
    KEY: "BACKUP",
    LABEL: "Backup",
  },
  MEMBER: {
    KEY: "MEMBER",
    LABEL: "Teamlid",
  },
};

const ORGANOGRAM = {
  WELDA: {
    KEY: "WELDA",
    LABEL: "Welda",
    dossierNrs: [10, 15],
    ROLES: {
      ...GENERIC_COMPANY_ROLES,
    },
    DEPARTMENTS: {
      MANAGEMENT: {
        KEY: "MANAGEMENT",
        LABEL: "Management",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          MANAGEMENT: {
            KEY: "MANAGEMENT",
            LABEL: "Management",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      HR: {
        KEY: "HR",
        LABEL: "HR",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          HR: {
            KEY: "HR",
            LABEL: "HR",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      SALES: {
        KEY: "SALES",
        LABEL: "Sales",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          EXTERNAL_SALES: {
            KEY: "EXTERNAL_SALES",
            LABEL: "Sales - Buitendienst",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
              REPRESENTATIVE: {
                KEY: "REPRESENTATIVE",
                LABEL: "Representative",
              },
            },
          },
          INTERNAL_SALES: {
            KEY: "INTERNAL_SALES",
            LABEL: "Sales - Binnendienst",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          STOREFRONT_SALES: {
            KEY: "STOREFRONT_SALES",
            LABEL: "Sales - Winkel",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          WEBSHOP_SALES: {
            KEY: "WEBSHOP_SALES",
            LABEL: "Sales - Webshop",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      PURCHASING_AND_TRANSPORT: {
        KEY: "PURCHASING_AND_TRANSPORT",
        LABEL: "Aankoop & Transport",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          PURCHASING: {
            KEY: "PURCHASING",
            LABEL: "Aankoop",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          TRANSPORT: {
            KEY: "TRANSPORT",
            LABEL: "Transport",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      MARKETING: {
        KEY: "MARKETING",
        LABEL: "Marketing",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          MARKETING: {
            KEY: "MARKETING",
            LABEL: "Marketing",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          PIM_AND_ECOMMERCE: {
            KEY: "PIM_AND_ECOMMERCE",
            LABEL: "PIM & E-commerce",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      SERVICE: {
        KEY: "SERVICE",
        LABEL: "Services",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          LOGISTICS: {
            KEY: "LOGISTICS",
            LABEL: "Logistiek",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          SERVICE: {
            KEY: "SERVICE",
            LABEL: "Service",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
              TECHNICIAN: {
                KEY: "TECHNICIAN",
                LABEL: "Technician",
              },
              PLANNER: {
                KEY: "PLANNER",
                LABEL: "Planner",
              },
            },
          },
          IT: {
            KEY: "IT",
            LABEL: "IT",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          PROJECTS: {
            KEY: "PROJECTS",
            LABEL: "Projecten",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      FINANCE: {
        KEY: "FINANCE",
        LABEL: "Financieel",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          ACCOUNTING: {
            KEY: "ACCOUNTING",
            LABEL: "Boekhouding",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          ADMINISTRATION: {
            KEY: "ADMINISTRATION",
            LABEL: "Administratie",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
    },
  },
  WELDAMACHINERY: {
    KEY: "WELDAMACHINERY",
    LABEL: "Welda Machinery",
    dossierNrs: 15,
    ROLES: {
      ...GENERIC_COMPANY_ROLES,
    },
  },

  AWTECH: {
    KEY: "AWTECH",
    LABEL: "AW Tech",
    dossierNrs: [70],
    ROLES: {
      ...GENERIC_COMPANY_ROLES,
    },
    DEPARTMENTS: {
      MANAGEMENT: {
        KEY: "MANAGEMENT",
        LABEL: "Management",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {},
      },
      HR: {
        KEY: "HR",
        LABEL: "HR",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {},
      },
      SALES: {
        KEY: "SALES",
        LABEL: "Sales",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          EXTERNAL_SALES: {
            KEY: "EXTERNAL_SALES",
            LABEL: "Sales - Buitendienst",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          INTERNAL_SALES: {
            KEY: "INTERNAL_SALES",
            LABEL: "Sales - Binnendienst",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          STOREFRONT_SALES: {
            KEY: "STOREFRONT_SALES",
            LABEL: "Sales - Winkel",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          WEBSHOP_SALES: {
            KEY: "WEBSHOP_SALES",
            LABEL: "Sales - Webshop",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      PURCHASING_AND_TRANSPORT: {
        KEY: "PURCHASING_AND_TRANSPORT",
        LABEL: "Aankoop & Transport",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          PURCHASING: {
            KEY: "PURCHASING",
            LABEL: "Aankoop",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          TRANSPORT: {
            KEY: "TRANSPORT",
            LABEL: "Transport",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
      SERVICE: {
        KEY: "SERVICE",
        LABEL: "Services",
        ROLES: {
          ...GENERIC_DEPARTMENT_ROLES,
        },
        TEAMS: {
          LOGISTICS: {
            KEY: "LOGISTICS",
            LABEL: "Reparatie",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          SERVICE: {
            KEY: "SERVICE",
            LABEL: "Service",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          IT: {
            KEY: "IT",
            LABEL: "IT",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
          PROJECTS: {
            KEY: "PROJECTS",
            LABEL: "Projecten",
            ROLES: {
              ...GENERIC_TEAM_ROLES,
            },
          },
        },
      },
    },
  },
  AMDI: {
    LABEL: "AMDI",
    dossierNr: 20,
    ROLES: {
      ...GENERIC_COMPANY_ROLES,
    },
  },
  METANOX: {
    LABEL: "Metanox",
    dossierNr: 99, // TODO: unkown for now
    ROLES: {
      ...GENERIC_COMPANY_ROLES,
    },
  },
};

const ROLES = {
  "Ken Van Leeuwe": [
    { key: "WELDA.EMPLOYER", label: "Eigenaar" },
    { key: "WELDA.SHAREHOLDER", label: "Aandeelhouder" },
    {
      key: "WELDA.MANAGEMENT.SUPERVISOR",
      label: "Management Supervisor",
      isDefault: true,
    },

    {
      key: "WELDA.MANAGEMENT.MANAGEMENT.TEAMLEADER",
      label: "Management Teamleider",
      isDefault: true,
    },
    { key: "WELDA.SERVICE.PROJECTS.TEAMLEADER", label: "Projecten Teamleider" },
    { key: "AWTECH.SHAREHOLDER", label: "Aandeelhouder" },
    { key: "METANOX.SHAREHOLDER", label: "Aandeelhouder" },
  ],
  "Stephanie De Walsche": [
    { key: "WELDA.EMPLOYER", label: "Eigenaar" },
    { key: "WELDA.SHAREHOLDER", label: "Aandeelhouder" },
    { key: "WELDA.MANAGEMENT.MANAGEMENT.MEMBER", label: "Management Lid" },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.SUPERVISOR",
      label: "Aankoop & Transport Supervisor",
      isDefault: true,
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.PURCHASING.TEAMLEADER",
      label: "Aankoop Teamleider",
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.TRANSPORT.TEAMLEADER",
      label: "Transport Teamleider",
    },
    { key: "AWTECH.SHAREHOLDER", label: "Aandeelhouder" },
    { key: "METANOX.SHAREHOLDER", label: "Aandeelhouder" },
  ],
  "Joeri De Smet": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.MANAGEMENT.MANAGEMENT.MEMBER", label: "Management Lid" },
    {
      key: "WELDA.FINANCE.SUPERVISOR",
      label: "Financieel Supervisor",
      isDefault: true,
    },
    {
      key: "WELDA.FINANCE.ACCOUNTING.TEAMLEADER",
      label: "Boekhouding Teamleider",
    },
    {
      key: "WELDA.FINANCE.ADMINISTRATION.TEAMLEADER",
      label: "Administratie Teamleider",
    },
  ],
  "Evy Bracke": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.SERVICE.HR.SUPERVISOR",
      label: "HR Supervisor",
      isDefault: true,
    },
  ],

  "Curt Venneman": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.INTERNAL_SALES.MEMBER",
      label: "Sales Binnendienst Lid",
      isDefault: true,
    },
  ],
  "Chris Witdouck": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.INTERNAL_SALES.MEMBER",
      label: "Sales Binnendienst Lid",
      isDefault: true,
    },
  ],
  "Koen Dedapper": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.INTERNAL_SALES.MEMBER",
      label: "Sales Binnendienst Lid",
      isDefault: true,
    },
  ],

  "Wim De Schryver": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.INTERNAL_SALES.MEMBER",
      label: "Sales Binnendienst Lid",
      isDefault: true,
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.PURCHASING.BACKUP",
      label: "Aankoop Backup",
    },
  ],

  "Sam Mussche": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.STOREFRONT_SALES.TEAMLEADER",
      label: "Sales Winkel Teamleider",
      isDefault: true,
    },
  ],
  "Mathias Devijver": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.STOREFRONT_SALES.MEMBER",
      label: "Sales Winkel Lid",
      isDefault: true,
    },
  ],
  "Bart Demeulemeester": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.STOREFRONT_SALES.MEMBER",
      label: "Sales Winkel Lid",
      isDefault: true,
    },
  ],
  "Lynn Callant": [
    "WELDA.EMPLOYEE",
    { key: "WELDA.FINANCE.MEMBER", label: "Financieel Lid" },
    {
      key: "WELDA.ACCOUNTING.MEMBER",
      label: "Accounting Lid",
      isDefault: true,
    },
  ],
  "Nathalia Steyaert": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.FINANCE.MEMBER", label: "Financieel Lid" },
    {
      key: "WELDA.FINANCE.ADMINISTRATION.MEMBER",
      label: "Administratie Lid",
      isDefault: true,
    },
    {
      key: "WELDA.FINANCE.ACCOUNTING.SUPPORT",
      label: "Accounting Ondersteuning",
    },
  ],
  "Sven De Schoenmacker": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.SUPERVISOR", label: "Service Supervisor" },
    {
      key: "WELDA.SERVICE.IT.TEAMLEADER",
      label: "IT Teamleider",
      isDefault: true,
    },
    { key: "WELDA.SERVICE.SERVICE.TEAMLEADER", label: "Service Teamleider" },
    { key: "WELDA.SERVICE.SERVICE.TECHNICIAN", label: "Service Technicus" },
    { key: "WELDA.SERVICE.PROJECTS.MEMBER", label: "Projecten Lid" },
  ],
  "Rudy Vanden Daele": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.SERVICE.TEAMLEADER",
      label: "Service Teamleider",
      isDefault: true,
    },
    { key: "WELDA.SERVICE.SERVICE.TECHNICIAN", label: "Service Technicus" },
  ],

  "Sam Detry": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    { key: "WELDA.SERVICE.IT.MEMBER", label: "IT Lid", isDefault: true },
  ],

  "Bram Van de Velde": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.LOGISTICS.TEAMLEADER",
      label: "Logistiek Teamleider",
      isDefault: true,
    },
  ],
  "Peter Vanryckel": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.LOGISTICS.MEMBER",
      label: "Logistiek Lid",
      isDefault: true,
    },
  ],
  "Philippe Albrecht": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.LOGISTICS.MEMBER",
      label: "Logistiek Lid",
      isDefault: true,
    },
  ],

  "Ellen Geirnaert": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.MEMBER",
      label: "Aankoop & Transport Lid",
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.PURCHASING.SUPPORT",
      label: "Aankoop Ondersteuning",
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.TRANSPORT.MEMBER",
      label: "Transport Lid",
      isDefault: true,
    },
  ],
  "Nathasja Steyaert": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.MEMBER",
      label: "Aankoop & Transport Lid",
    },
    {
      key: "WELDA.PURCHASING_AND_TRANSPORT.PURCHASING.MEMBER",
      label: "Aankoop Lid",
      isDefault: true,
    },
  ],
  "Frede De Witte": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.MARKETING.SUPERVISOR",
      label: "Marketing Supervisor",
      isDefault: true,
    },
    {
      key: "WELDA.MARKETING.MARKETING.TEAMLEADER",
      label: "Marketing Teamleider",
    },
    {
      key: "WELDA.MARKETING.PIM_AND_ECOMMERCE.TEAMLEADER",
      label: "PIM & E-commerce Teamleider",
    },
  ],
  "Jasper Dejonckheere": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.MARKETING.MEMBER", label: "Marketing Lid" },
    {
      key: "WELDA.MARKETING.PIM_AND_ECOMMERCE.MEMBER",
      label: "PIM & E-commerce Lid",
      isDefault: true,
    },
  ],
  "Thijs Dejonckheere": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.MARKETING.MEMBER", label: "Marketing Lid" },
    {
      key: "WELDA.MARKETING.PIM_AND_ECOMMERCE.MEMBER",
      label: "PIM & E-commerce Lid",
      isDefault: true,
    },
  ],
  "Peter De Jaeger": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.MARKETING.MEMBER", label: "Marketing Lid" },
    {
      key: "WELDA.MARKETING.MARKETING.MEMBER",
      label: "Marketing Lid",
      isDefault: true,
    },
  ],
  "Dominiek Vandeputte": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.MARKETING.MEMBER", label: "Marketing Lid" },
    {
      key: "WELDA.MARKETING.MARKETING.MEMBER",
      label: "Marketing Lid",
      isDefault: true,
    },
  ],
  "Koen De Bruyne": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.SALES.SUPERVISOR",
      label: "Sales Supervisor",
      isDefault: true,
    },
    {
      key: "WELDA.SALES.INTERNAL_SALES.TEAMLEADER",
      label: "Sales Binnendienst Teamleider",
    },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.TEAMLEADER",
      label: "Sales Buitendienst Teamleider",
    },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
    },
  ],
  "Koen De Bruyne (M)": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    {
      key: "WELDA.SALES.SUPERVISOR",
      label: "Sales Supervisor",
      isDefault: true,
    },
    {
      key: "WELDA.SALES.INTERNAL_SALES.TEAMLEADER",
      label: "Sales Binnendienst Teamleider",
    },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.TEAMLEADER",
      label: "Sales Buitendienst Teamleider",
    },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
    },
  ],
  "Dirk Antonis": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
    },
  ],
  "Jonas De Bock": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
  "Stefan Dekeukelaere": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
  "Nicolas Bruggeman": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
  "Sanny De Baere": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SALES.MEMBER", label: "Sales Lid" },
    {
      key: "WELDA.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],

  "Jorg Welda": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.SERVICE.TECHNICIAN",
      label: "Service Technicus",
      isDefault: true,
    },
  ],
  "Jens Van Hecke": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.SERVICE.TECHNICIAN",
      label: "Service Technicus",
      isDefault: true,
    },
  ],
  "Tom Casaert": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.SERVICE.TECHNICIAN",
      label: "Service Technicus",
      isDefault: true,
    },
  ],
  "Tom Martens": [
    { key: "WELDA.EMPLOYEE", label: "Werknemer" },
    { key: "WELDA.SERVICE.MEMBER", label: "Service Lid" },
    {
      key: "WELDA.SERVICE.SERVICE.TECHNICIAN",
      label: "Service Technicus",
      isDefault: true,
    },
  ],

  "Elias Becue": [
    { key: "AWTECH.EMPLOYEE", label: "Werknemer" },
    {
      key: "AWTECH.SERVICE.LOGISTICS.TEAMLEADER",
      label: "Logistiek Teamleider",
      isDefault: true,
    },
  ],
  "Kirsten Pape": [{ key: "AWTECH.EMPLOYEE", label: "Werknemer" }],
  "Stefaan Gevaert": [
    { key: "AWTECH.EMPLOYEE", label: "Werknemer" },
    { key: "AWTECH.MANAGEMENT.MEMBER", label: "Management Lid" },
    {
      key: "AWTECH.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
  "Dieter Grimmonprez": [
    { key: "AWTECH.EMPLOYEE", label: "Werknemer" },
    {
      key: "AWTECH.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
  "Henk Grootaerd": [
    { key: "AWTECH.EMPLOYEE", label: "Werknemer" },
    {
      key: "AWTECH.SALES.EXTERNAL_SALES.REPRESENTATIVE",
      label: "Sales Buitendienst Vertegenwoordiger",
      isDefault: true,
    },
  ],
};

const CONTACT_TYPE_CODES = {
  COMPANY: "1",
  CONTACT_PERSON: "2",
  DEPARTMENT: "4",
  DELIVERY: "10",
};

// The code below is to set the roles for the employees in the database. Only use to reset roles after a major change in the roles structure above.

// async function setRoles() {
//   for (const role of Object.keys(ROLES)) {
//     console.info("setting roles for", role);
//     try {
//       await Employee.findOneAndUpdate(
//         { name: role },
//         { $set: { roles: ROLES[role] } },
//         { new: true }
//       );
//     } catch (error) {
//       console.error("error setting roles for", role, error);
//     }
//   }
// }

// setRoles();

module.exports = {
  ORGANOGRAM,
  DEPARTMENTS,
  WS_APPLICATIONS,
  ROLES,
  CONTACT_TYPE_CODES,
};
